import React from 'react';

const IconRenderer = ({ icon }) => {

  // If there is no icon configuration, return null.
  if (!icon) return null;

  // If it is an image-type icon.
  if (icon.type === 'image') {
    return (
      <img 
        src={require(`../../src/assets/images/image_icons/${icon.name}.png`)}
        alt=""
        style={{ width: '24px', height: '24px' }}
      />
    );
  }
  // It uses Material Icons for default
  return (
    <span className="material-symbols-outlined">
      {icon.name}
    </span>
  );
};

export default IconRenderer; 